import { render, staticRenderFns } from "./QrcodeView.vue?vue&type=template&id=2dc8e247&"
import script from "./QrcodeView.vue?vue&type=script&lang=js&"
export * from "./QrcodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports